import { render, staticRenderFns } from "./fastvaluedeal-compare-benefits.vue?vue&type=template&id=46b161a0&scoped=true&"
import script from "./fastvaluedeal-compare-benefits.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-compare-benefits.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-compare-benefits.vue?vue&type=style&index=0&id=46b161a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b161a0",
  null
  
)

export default component.exports